module.exports = __webpack_public_path__ + "static/media/adaptive_concepts.5f4413e6.webp";